import React from "react";
import PeriodFilter from "./PeriodFilter";

export default function LastUpdateFilter(props) {
    return <PeriodFilter {...props} dateType="lastUpdate" />;
}
